/**
 * DemoController — boots the simulated build straight into the full-screen
 * topology viewer and starts the simulation. Rendered once (inside RootLayout)
 * only when DEMO_MODE is on. Renders nothing.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { wsClient } from "../api/ws.js";
import { useWorldStore } from "../stores/world.js";
import { MockWsClient } from "./MockWsClient.js";
import { demoSimulation } from "./DemoSimulation.js";
import { DEFAULT_DEMO_TOPOLOGY_ID } from "./topologies.js";

export function DemoController() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Agents World";
    const store = useWorldStore.getState();
    store.setViewMode("pixel");
    store.setFullscreen(true);
    // Select via the URL — TopologyView treats the route param as the source of
    // truth for the selected topology, so setting the store directly would be
    // clobbered. The mock backend serves a topology for this id.
    navigate(`/topology/${DEFAULT_DEMO_TOPOLOGY_ID}`, { replace: true });

    if (wsClient instanceof MockWsClient) {
      wsClient.connect();
      demoSimulation.start(wsClient);
    }

    return () => demoSimulation.stop();
  }, [navigate]);

  return null;
}
